import { UserContext } from 'context/UserContext';
import { useContext, useRef } from 'react';
// import { CgComment } from 'react-icons/cg';
// import { MdTabUnselected } from 'react-icons/md';
import { ROLES } from 'utilities/constants';
import Icons from 'assets/Icons';

function SelectionBlock({ fns = {} }) {
  const ref = useRef();
  const { setCommentsModal, removeExistingSelections } = fns;

  const { userInfo = {} } = useContext(UserContext);
  const isSE = userInfo?.data?.key === ROLES.SUBJECT_EXPERT;

  if (isSE) return null;

  return (
    <div
      id="floating-selection-bubble"
      className="app-l-icon-popover-wrapper position-absolute"
      ref={ref}
    >
      <div className="app-l-icon-popover d-flex align-items-center justify-content-center">
        <button
          type="button"
          class="btn btn-link"
          title="Add comment"
          onClick={() => {
            const data = ref.current.getAttribute('data-json-id');
            if (data) {
              setCommentsModal(JSON.parse(data));
            }
          }}
        >
          <Icons.addChatIcon />
        </button>
        <button
          type="button"
          class="btn btn-link"
          title="Undo selection"
          onClick={() => {
            removeExistingSelections();
            ref.current.style.display = 'none';
          }}
        >
          <Icons.expandIcon />
        </button>
        {/* <button type="button" class="btn btn-link">
          <Icons.editIcon />
        </button> */}
        {/* <button type="button" class="btn btn-link">
          <Icons.deleteIcon />
        </button> */}
        {/* <button type="button" class="btn btn-link">
          <Icons.imageEditIcon />
        </button> */}
      </div>
      <div className="app-l-icon-popover-wrapper__downArrow">
        <Icons.downArrow />
      </div>
    </div>
  );

  // return (
  //   <div id="floating-selection-bubble" className="position-absolute" ref={ref}>
  //     <div
  //       className="displayPointer"
  //       title="Undo selection"
  //       onClick={() => {
  //         removeExistingSelections();
  //         ref.current.style.display = 'none';
  //       }}
  //     >
  //       <MdTabUnselected color="red" />
  //     </div>
  //     <div
  //       title="Add comment"
  //       className="displayPointer"
  //       onClick={() => {
  //         const data = ref.current.getAttribute('data-json-id');
  //         if (data) {
  //           setCommentsModal(JSON.parse(data));
  //         }
  //       }}
  //     >
  //       <CgComment color="blue" />
  //     </div>
  //   </div>
  // );
}

export default SelectionBlock;
